import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { CouponUsersTemplate } from 'components/Templates'

const CouponUsers: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const couponId = /^\/admin\/coupon\/[a-zA-Z0-9]+\/user$/.test(pathname) ? pathname.split('/')[3] : undefined

  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'配布済みユーザー一覧'}>
      <CouponUsersTemplate couponId={couponId} />
    </Layout>
  )
}

export default CouponUsers
